//
//
//
//
//
//

export default {
  name: 'SubscribeHero2026PromoVideo',
  data() {
    return {
      promoVideoPath: '/img/subscribe/subscription-ai-remix-2026.260522.mp4',
    };
  },
  mounted() {
    this.playTimeout = setTimeout(() => {
      if (this.$refs.video) {
        this.$refs.video.play().catch(() => {
          // Handle or ignore autoplay block
        });
      }
    }, 1800);
  },
  beforeDestroy() {
    clearTimeout(this.playTimeout);
  },
};
